{
  "version": 1,
  "asset_id": "08d76ff9-be62-4bdf-9b3a-1e62f4d63a8c",
  "project_id": "449b2c5b-fdd9-48b8-8f0a-7dd2027bc221",
  "url": "/__l5e/assets-v1/08d76ff9-be62-4bdf-9b3a-1e62f4d63a8c/bananaballnation.webp",
  "r2_key": "a/v1/449b2c5b-fdd9-48b8-8f0a-7dd2027bc221/08d76ff9-be62-4bdf-9b3a-1e62f4d63a8c/bananaballnation.webp",
  "original_filename": "bananaballnation.webp",
  "size": 735455,
  "content_type": "image/png",
  "created_at": "2026-06-02T23:56:59Z"
}
